import React, { useState, useEffect } from "react";
import "./Track-order.css";
import "../../assets/css/modal.css";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { trackOrder } from "../../actions/productActions";
import SingleOrder from "./SingleOrder";
import image4 from "../../assets/images/trackorder.jpg";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import Pusher from "pusher-js";

const OrderList = ({ order, getCartDetails }) => {
  const elements = [];

  if (order && order.length !== 0) {
    for (let i = 0; i < order.length; ++i) {
      elements.push(
        <SingleOrder
          key={order[i].id || i}
          order={order[i]}
          cartDetails={getCartDetails}
        />
      );
    }
  } else {
    elements.push(
      <h5
        className="no-order-img"
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
        }}
        key="no-orders"
      >
        <img
          src={image4}
          alt="No orders"
          style={{ height: "350px", width: "350px", marginBottom: "20px" }}
        />
        No pending order at this moment
      </h5>
    );
  }

  return <div id="order-list">{elements}</div>;
};

const TrackOrder = (props) => {
  const [page, setPage] = useState(1);
  const [orders, setOrders] = useState(props.order || []);

  useEffect(() => {
    if (props.order) {
      setOrders(props.order);
    }
  }, [props.order]);

  useEffect(() => {
    props.trackOrder(page);
  }, [page]);

  useEffect(() => {
    if (!props.loader) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [props.loader]);

  useEffect(() => {
    Pusher.logToConsole = true;
    const pusher = new Pusher("7dc08a86c76a0bd7effd", {
      cluster: "ap1",
      forceTLS: true
    });
    
    const channel = pusher.subscribe("test-channel");
    
    channel.bind("test-event", function (data) {
      console.log("Pusher Update Received in TrackOrder:", data);

      if (
        data?.message && 
        localStorage.getItem("location_id") === String(data.location_id) && 
        localStorage.getItem("business_id") === String(data.business_id)
      ) {
        console.log("Checking orders for ID:", data.order_id);

        setOrders(prevOrders => {
          const orderIndex = prevOrders.findIndex(
            order => String(order.id) === String(data.id)
          );

          if (orderIndex !== -1) {
            console.log("✅ Found order at index:", orderIndex);
            
            const updatedOrders = [...prevOrders];
            updatedOrders[orderIndex] = {
              ...updatedOrders[orderIndex],
              lalamove_status: data.status || updatedOrders[orderIndex].lalamove_status,
              estimated_arrival_time: data.estimated_arrival_time || updatedOrders[orderIndex].estimated_arrival_time,
              lalamove_driver_info: data.driver_info || updatedOrders[orderIndex].lalamove_driver_info,
              d_address: data.d_address || updatedOrders[orderIndex].d_address,
              paymentType: data.paymentType || updatedOrders[orderIndex].paymentType,
              last_4_card_digits: data.last_4_card_digits || updatedOrders[orderIndex].last_4_card_digits,
              business_location_mobile_for_delivery: data.business_location_mobile_for_delivery || updatedOrders[orderIndex].business_location_mobile_for_delivery,
              pickup_completed: data.pickup_completed !== undefined ? data.pickup_completed : updatedOrders[orderIndex].pickup_completed,
            };

            return updatedOrders;
          } else {
            console.log("Order not found in current page");
            return prevOrders;
          }
        });
      }
    });

    return () => {
      channel.unbind_all();
      pusher.unsubscribe("test-channel");
      pusher.disconnect();
    };
  }, []); 

  return (
    <>
      {!props.loader && (
        <div>
          <OrderList order={orders} getCartDetails={props.getCartDetails} />

          <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
            <Pagination
              className="custom-pagination"
              current={page}
              total={props.total_orders || 0}
              pageSize={5}
              onChange={(pageNumber) => setPage(pageNumber)}
              showTotal={(total, range) =>
                `Showing ${range[0]}–${range[1]} of ${total}`
              }
            />
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  order: state.products.track_order,
  total_orders: state.products.total_orders,
  loader: state.products.loader,
});

export default withTranslation()(
  connect(mapStateToProps, { trackOrder })(TrackOrder)
);
